import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-authorized-modal',
    templateUrl: './authorized-modal.component.html',
    styleUrls: ['./authorized-modal.component.scss']
})
export class AuthorizedModalComponent {
    constructor(private _dialog: MatDialog) {}
    onUserConfirm() {
        localStorage.setItem('isShowConfirmation', 'true');
        this._dialog.closeAll();
    }
}
